
import { Component, Vue } from 'vue-property-decorator';
import { ClientConstants } from '../../client.constants';

@Component({})
export default class MainFooterBlock extends Vue {
    clientConstants = ClientConstants;
}
